import { Model } from 'backbone';

export default class Coach extends Model {
	initialize() {
		this.prefix = 'nrl/';
		this.url = 'coach/players.json';
	}
}